const data = [
    {
        "id": 1, "label": "待遇面議"
    },
    {
        "id": 2, "label": "月薪 40,000 ~ 60,000 元"
    },
    {
        "id": 3, "label": "月薪 70,000 ~ 10,000 元"
    },
    {
        "id": 4, "label": "年薪 800,000 ~ 1,000,000 元"
    },
    {
        "id": 5, "label": "年薪 800,000 ~ 1,500,000 元"
    },
    {
        "id": 6, "label": "年薪 1,500,000 ~ 2,000,000 元"
    },
    {
        "id": 7, "label": "年薪 2,000,000 ~ 2,500,000 元"
    }
]

export default data